export default "__VITE_ASSET__dadf561e__"